// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "flow.details.expired.action": "Choose another time",
  "flow.details.account.heading": "Your details",
  "flow.details.name.label": "Name · required",
  "flow.details.name.placeholder": "Your name",
  "flow.details.name.error": "Enter the name for this appointment.",
  "flow.details.email.label": "Email · required",
  "flow.details.email.placeholder": "you@example.com",
  "flow.details.email.hint": "Booking updates go here.",
  "flow.details.email.error": "Enter an email address for this booking.",
  "flow.signin.heading": "Sign in",
  "flow.signin.intro": "",
  "flow.signin.optionalIntro": "",
  "flow.signin.apple": "Continue with Apple",
  "flow.signin.google": "Continue with Google",
  "flow.signin.apple.busy": "Waiting for Apple",
  "flow.signin.google.busy": "Waiting for Google",
  "flow.signin.provider.hint": "Continue in the pop-up.",
  "flow.signin.or": "or",
  "flow.signin.email.label": "Email",
  "flow.signin.email.placeholder": "you@example.com",
  "flow.signin.password.label": "Password",
  "flow.signin.password.placeholder": "Your password",
  "flow.signin.submit": "Sign in",
  "flow.signin.submitting": "Signing in",
  "flow.signin.error.provider": "Sign-in didn’t finish. Try again.",
  "flow.signin.error.providerCollision": "Use your usual sign-in method.",
  "flow.signin.error.providerBlocked": "Allow pop-ups for Lura before trying again.",
  "flow.signin.error.providerUnavailable": "Continue with your email and password.",
  "flow.signin.error.bookingPending": "Check the result before switching accounts.",
  "flow.signin.error.credentials": "Check your email and password.",
  "flow.signin.forgot": "Forgot your password?",
  "flow.signin.create": "Create an account",
  // copy-1 (Founder-approved, 2026-10-06): why the client is signed out, on
  // the sign-in step (shared/hooks/useSignOutNotice.ts). The deliberate line
  // has no prompt to sign back in, by decision.
  "flow.signin.notice.sessionEnded": "Your session ended. Sign in to continue.",
  "flow.signin.notice.signedOut": "You’re signed out.",
  // App's approved `login.signOut`, reused exactly (Director, 2026-10-07):
  // same product, same meaning, approved by the Founder in both languages.
  "flow.signOut": "Sign out",
  // The footer's session row (designer, lura-web-v3 "Oct 7 · Sign out
  // (Book)"): "Signed in as <email>", the design's own strings.
  "flow.session.signedInAs": "Signed in as",
  "flow.create.heading": "Create your account",
  "flow.create.heading.existing": "Complete your account",
  "flow.create.firstName": "First name",
  "flow.create.lastName": "Last name",
  "flow.create.email": "Email",
  "flow.create.password": "Password",
  "flow.create.submit": "Create account",
  "flow.create.submit.existing": "Complete account setup",
  "flow.create.working": "Working…",
  "flow.create.verify.body": "Check {email} for a verification link.",
  "flow.create.verify.check": "I’ve verified my email",
  "flow.create.verify.resend": "Send email again",
  "flow.create.signIn": "Already have an account? Sign in",
  "flow.create.switchAccount": "Use another account",
  "flow.create.error.names": "Enter your first and last name.",
  "flow.create.error.credentials": "Enter an email and password to continue.",
  "flow.create.error.unverified": "Check {email} for a verification link.",
  "flow.create.error.generic": "We couldn’t create your account.",
  "flow.create.error.setup": "We couldn’t finish setting up your account.",
  // rc.9 DRAFTS, pending the Founder's copy sheet (lura-copy-review-rc9-2026-10-15.csv).
  "flow.create.inProgress": "We’re still setting up your account. Try again in a moment.",
  "flow.create.supportRequired": "Email Lura support for help with your account.",
  "flow.create.error.providerEmail": "Use another account to continue.",
  "flow.create.error.support": "Email Lura support",
} as const;
